import { Platform } from 'quasar';

/**
 * Vue3 composable to display a PDF file in an iframe element.
 * Opens the PDF file in a new tab using the URL.createObjectURL() method.
 * @param {Blob} pdf - The PDF file as a Blob object.
 * @param {string} certificateTitle - The title of the PDF file.
 */
export default function useDisplayPdf(pdf: Blob, certificateTitle: string) {
    const file = new File([pdf], 'Certificate.pdf', { lastModified: Date.now(), type: pdf.type });
    const url = URL.createObjectURL(file);

    // Create an iframe element and set its attributes.
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = 'none';

    // Check for Safari
    if (Platform.is.safari) {
        // build a link and click it (open in new window)
        const link = document.createElement('a');
        link.href = url;
        link.download = certificateTitle;

        // Append the link to the body
        document.body.appendChild(link);

        link.click();

        // Remove the link when done
        document.body.removeChild(link);
    } else {
        const tab = window.open();
        if (tab) {
            const title = document.createElement('title');
            title.append(certificateTitle);
            tab.document.head.append(title);
            tab.document.body.style.margin = '0px';
            tab.document.body.append(iframe);
        }
    }

    // We no longer need the URL object, so we revoke it.
    URL.revokeObjectURL(url);
}
